import React, { useEffect, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from 'ddc-classnames-js';
import MediaContainer from './MediaContainer';
import DetailsContainer from './DetailsContainer';
import FooterContainer from './FooterContainer';
import ShowOffSiteInfo from './ShowOffSiteInfo';
import CardInnerSkeleton from './CardInnerSkeleton';

const VehicleCard = ({
	accounts,
	doFullRender,
	enableCompare,
	enableMediaCarousel,
	incentives,
	isGridLayout,
	isMyCarsSitePropEnabled,
	isTabbedLayout,
	observerRef,
	vehicleImageObs,
	setShowOffSite,
	vehicle
}) => {
	const cardRef = useRef();
	useEffect(() => {
		if (observerRef && observerRef.current && cardRef && cardRef.current) {
			observerRef.current.observe(cardRef.current);
		}
	}, [cardRef, observerRef]);
	const { uuid, link } = vehicle;
	let cardContents;
	if (doFullRender) {
		cardContents = (
			<React.Fragment>
				{setShowOffSite && (
					<ShowOffSiteInfo handleClick={() => setShowOffSite(true)} />
				)}
				<div
					className={setClassNames([
						'vehicle-card-body',
						'ddc-font-size-small',
						isGridLayout ? null : 'd-sm-flex', // TODO: deprecate
						isGridLayout ? null : 'flex-sm-row' // TODO: deprecate
					])}
				>
					<MediaContainer
						{...{
							enableMediaCarousel,
							isTabbedLayout,
							vehicle,
							vehicleImageObs
						}}
						accountPhone={accounts[vehicle.accountId].phone}
					/>
					<DetailsContainer
						{...{
							vehicle,
							incentives,
							accounts,
							isTabbedLayout,
							isGridLayout
						}}
					/>
				</div>
				<FooterContainer
					{...{
						isTabbedLayout,
						enableCompare,
						isMyCarsSitePropEnabled,
						uuid,
						link
					}}
				/>
			</React.Fragment>
		);
	} else {
		cardContents = (
			<CardInnerSkeleton {...{ isGridLayout, isTabbedLayout }} />
		);
	}
	return useMemo(
		() => (
			<li
				ref={cardRef}
				key={uuid}
				className={setClassNames([
					'vehicle-card',
					'vehicle-card-detailed',
					isGridLayout ? null : 'vehicle-card-horizontal',
					setShowOffSite && 'vehicle-card-fade position-relative'
				])}
				data-uuid={uuid}
			>
				{cardContents}
			</li>
		),
		[uuid, isGridLayout, setShowOffSite, cardContents]
	);
};

VehicleCard.propTypes = {
	enableCompare: PropTypes.bool.isRequired,
	enableMediaCarousel: PropTypes.bool.isRequired,
	isGridLayout: PropTypes.bool.isRequired,
	isMyCarsSitePropEnabled: PropTypes.bool.isRequired,
	isTabbedLayout: PropTypes.bool.isRequired,
	incentives: PropTypes.shape({}).isRequired,
	accounts: PropTypes.shape({}).isRequired,
	vehicle: PropTypes.shape({}).isRequired,
	observer: PropTypes.shape({})
};

export default VehicleCard;
